import React, { ProviderProps, ReactNode, useMemo, useRef, useState } from "react";

export type TACOContext = {
    bongoStay : boolean,
    gameOn : boolean,
    diningIn : boolean,
    darkMode : boolean,
    enterGame : () => void,
    exitGame : (h: boolean) => void,
    enterShop : () => void,
    exitShop : () => void
};

const context = React.createContext<TACOContext>({
    bongoStay : false,
    gameOn : false,
    diningIn : false,
    darkMode : false,
    enterGame : () => {},
    exitGame : (h: boolean) => {},
    enterShop : () => {},
    exitShop : () => {}
});

const TACOProvider = (props: { children: ReactNode }) => {
    const bongoStay = useRef(false);
    const gameOn = useRef(false);
    const diningIn = useRef(false);
    const [darkMode, setDarkMode] = useState(false);

    const enterGame = () => {
        gameOn.current = true;
        bongoStay.current = false;
        diningIn.current = false;
        setDarkMode(true);
    };

    const exitGame = (h: boolean) => {
        gameOn.current = false;
        if (h) bongoStay.current = true;
        setDarkMode(false);
    };

    const enterShop = () => {
        diningIn.current = true;
        gameOn.current = false;
        setDarkMode(true);
    };

    const exitShop = () => {
        diningIn.current = false;
        setDarkMode(false);
    };

    const value : TACOContext = useMemo(() => {
        return { 
            bongoStay: bongoStay.current, 
            gameOn: gameOn.current, 
            diningIn: diningIn.current, 
            darkMode,
            enterGame,
            exitGame,
            enterShop,
            exitShop 
    }}, [darkMode]);

    return (
        <context.Provider value={value}>
            {props.children}
        </context.Provider>
    );
};

TACOProvider.context = context;

export default TACOProvider;